export enum IPlanCode {
  SEASONAL = 'fffvip',
  ANNUAL = 'fffvipa',
}
